import { handleActions } from 'redux-actions';
import {
  SET_PROJECT_DATA,
  CLEAR_PROJECT_DATA,
  SET_INVITE_DATA,
  CLEAR_INVITE_DATA,
  SET_ASSESSMENT_DATA,
  CLEAR_ASSESSMENT_DATA,
  SET_PROJECT_STEP,
  SET_MEDIA_PERMISSIONS,
  SET_POD_CREATION_STATUS,
  SET_IDE_URL,
  SET_SESSION_DATA,
  CLEAR_SESSION_DATA,
  UPDATE_ASSESSMENT_DATA,
  SET_ERROR,
  CLEAR_ERROR,
  SET_LAUNCHING_SESSION,
} from '../actions/ProjectActions';

const initialState = {
  project: {},
  invite: {},
  assessment: {},
  session: {},
  mediaPermissions: {
    camera: false,
    screen: false,
  },
  podCreationStatus: '',
  ideUrl: null,
  launchingSession: false,
  error: null,
};

const ProjectReducer = handleActions(
  {
    [SET_PROJECT_DATA]: (state, action) => ({
      ...state,
      project: {
        ...state.project,
        ...action.payload,
      },
    }),
    [CLEAR_PROJECT_DATA]: (state, action) => ({
      ...state,
      project: {},
    }),
    [SET_SESSION_DATA]: (state, action) => {
      return {
        ...state,
        session: {
          ...state.session,
          ...action.payload,
        },
      };
    },
    [CLEAR_SESSION_DATA]: (state, action) => ({
      ...state,
      session: {},
    }),
    [SET_INVITE_DATA]: (state, action) => ({
      ...state,
      invite: {
        ...state.invite,
        ...action.payload,
      },
    }),
    [CLEAR_INVITE_DATA]: (state, action) => ({
      ...state,
      invite: {},
    }),
    [SET_ASSESSMENT_DATA]: (state, action) => ({
      ...state,
      assessment: {
        ...state.assessment,
        ...action.payload,
      },
    }),
    [UPDATE_ASSESSMENT_DATA]: (state, action) => ({
      ...state,
      assessment: {
        ...state.assessment,
        ...action.payload,
      },
    }),
    [CLEAR_ASSESSMENT_DATA]: (state, action) => ({
      ...state,
      assessment: {},
    }),
    [SET_PROJECT_STEP]: (state, action) => ({
      ...state,
      step: action.payload,
    }),
    [SET_MEDIA_PERMISSIONS]: (state, action) => ({
      ...state,
      mediaPermissions: {
        ...state.mediaPermissions,
        ...action.payload,
      },
    }),
    [SET_POD_CREATION_STATUS]: (state, action) => ({
      ...state,
      podCreationStatus: action.payload,
    }),
    [SET_IDE_URL]: (state, action) => ({
      ...state,
      ideUrl: action.payload,
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      error: {
        status: action.payload.status,
        message: action.payload.message,
      },
    }),
    [CLEAR_ERROR]: (state, action) => ({
      ...state,
      error: null,
    }),
    [SET_LAUNCHING_SESSION]: (state, action) => ({
      ...state,
      launchingSession: action.payload,
    }),
  },
  initialState,
);

export default ProjectReducer;
